import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";
import { useCurrentUser } from "../../slices/auth/hooks";

const Logout = (props) => {
  const dispatch = useDispatch();

  const currentUser = useCurrentUser();

  useEffect(() => {
    dispatch(logoutUser());
    localStorage.clear();
  }, [dispatch]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
